// extracted by mini-css-extract-plugin
export default {"container":"ImageModal_container__s-NCh","img_container":"ImageModal_img_container__JhaNb","header":"ImageModal_header__aiGbw"};